import { useEffect } from 'react';

export function useCleanup(func: () => void) {
  useEffect(() => {
    return func;
  }, []);
}
